
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import ReportView from '@/components/ReportView.vue'
import { ReportGroup } from '@/model/models'

export default defineComponent({
  name: 'Analytics',
  components: {
    Header,
    ReportView,
  },
  data () {
    return {
      reportId: '',
      reportGroups: [] as ReportGroup[],
      reportOptions: [{ label: '', options: [{ value: '', label: '' }] }],
      reportSelected: '',
      expandedGroups: new Map()
    }
  },
  created() {
    this.reportId = typeof this.$route.params.id === 'string' ? this.$route.params.id : ''
  },
  methods: {
    isExpanded(index: number) {
      return this.expandedGroups.get(index) === true
    },
    toggleGroup(index: number) {
      this.expandedGroups.set(index, !this.isExpanded(index))
    },
    onSelectReport() {
      if (this.reportSelected) {
        this.$router.push('/analytics/' + this.reportSelected)
      }
    }
  }
})
